<div class="dialog">
  <div class="info">
    <h3>Agente {{ fullName }}</h3>
    <div class="picker">
      <h4>Fecha de alta</h4>
      <qr-date-picker
        [config]="datePickerFrom"
        (datepickerChange)="datepickerFromChange($event)"
      ></qr-date-picker>
    </div>
  </div>
  <div class="footer">
    <p>
      *Los cambios en la fecha de alta afectarán las estadísticas del equipo y
      se verán reflejados al día siguiente.
    </p>
  </div>
</div>
